<template>
  <div>
    <div>
      <div class="action-buttons">
        <div class="left-button">
          <div class="form-group" style="flex: 1;">
            <label>{{ $t('gestiune.locatie') }}</label>
            <select class="form-control" v-model="selectedLocation" :disabled="loading">
              <option :value="null">Selectează</option>
              <optgroup
                v-for="group in groupedLocations"
                :key="group.vat"
                :label="`VAT: ${group.vat}`"
              >
                <option
                  v-for="loc in group.locations"
                  :key="loc.id"
                  :value="loc"
                >
                  {{ loc.name }}
                </option>
              </optgroup>
            </select>
          </div>
          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="onSearch"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
        </div>
            <div class="right-buttons">
              <!-- <button class="btn add mar-rt-10" type="success" @click="addMyOrder()">
                  <img src="/static/img/icons/add.png">
                  {{ $t('gestiune.addOrder') }}
              </button> -->
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="data-table">
              <el-table :data="tableData" :empty-text="$t('gestiune.noData')">
                <el-table-column label="Număr Document" prop="documentNumber">
                  <template slot-scope="scope">
                    {{ scope.row.documentNumber }}
                  </template>
                </el-table-column>

                <el-table-column label="Serie" prop="series">
                  <template slot-scope="scope">
                    {{ scope.row.series }}
                  </template>
                </el-table-column>

                <el-table-column label="Date" prop="date">
                  <template slot-scope="scope">
                    {{ new Date(scope.row.date).toLocaleDateString('ro-RO') }}
                  </template>
                </el-table-column>

                <el-table-column label="Status" prop="status">
                  <template slot-scope="scope">
                    <span :style="getStatusStyle(scope.row.status)">
                      {{ scope.row.status }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column v-if="showAvizColumn" label="Aviz" width="150">
                  <template slot-scope="scope">
                    {{ (scope.row.externalDocIds && scope.row.externalDocIds.aviz)
                        ? scope.row.externalDocIds.aviz.series + ' - ' + scope.row.externalDocIds.aviz.number
                        : '-' }}
                  </template>
                </el-table-column>

                <el-table-column v-if="showNirColumn" label="NIR" width="150">
                  <template slot-scope="scope">
                    {{ (scope.row.externalDocIds && scope.row.externalDocIds.nir)
                        ? scope.row.externalDocIds.nir.number
                        : '-' }}
                  </template>
                </el-table-column>

                <el-table-column v-if="showInvoiceColumn" label="Factura" width="150">
                  <template slot-scope="scope">
                    {{ (scope.row.externalDocIds && scope.row.externalDocIds.invoice)
                        ? scope.row.externalDocIds.invoice.series + ' - ' + scope.row.externalDocIds.invoice.number
                        : '-' }}
                  </template>
                </el-table-column>

                <el-table-column :label="$t('general.actions')" width="200">
                  <template slot-scope="scope">
                    <!-- Procesare comandă -->
                    <a
                      v-if="userHasRight('can_process_supplier_order')"
                      class="btn btn-info mar-rt-10"
                      @click="processOrder(scope.row)"
                      v-show="scope.row.status.toLowerCase() === 'sent'"
                    >
                      {{ $t('gestiune.process') }}
                    </a>

                    <!-- Aviz -->
                    <a
                      v-if="userHasRight('can_generate_aviz')"
                      class="btn btn-info mar-rt-10"
                      @click="aviz(scope.row)"
                      v-show="scope.row.status.toLowerCase() === 'processed' && !(scope.row.externalDocIds && scope.row.externalDocIds.aviz)"
                      :title="scope.row.status.toLowerCase() !== 'processed'
                              ? 'Avizul poate fi generat doar pentru comenzile procesate.'
                              : (scope.row.externalDocIds && scope.row.externalDocIds.aviz) ? 'Aviz deja generat' : ''"
                    >
                      <template v-if="scope.row.externalDocIds && scope.row.externalDocIds.aviz">
                        {{ $t('gestiune.aviz') }}: {{ scope.row.externalDocIds.aviz.series }} - {{ scope.row.externalDocIds.aviz.number }}
                      </template>
                      <template v-else>
                        {{ $t('gestiune.aviz') }}
                      </template>
                    </a>

                    <!-- Factură -->
                    <a
                      v-if="userHasRight('can_generate_invoice') && !(scope.row.supplierVatNumber && scope.row.supplierVatNumber === scope.row.vatNumber)"
                      class="btn btn-info mar-rt-10"
                      @click="invoice(scope.row)"
                      v-show="!(
                        ['sent', 'processed'].includes(scope.row.status.toLowerCase())
                        || (scope.row.externalDocIds && scope.row.externalDocIds.invoice)
                        || (scope.row.externalDocIds && 'bonTransfer' in scope.row.externalDocIds)
                      )"
                      :title="['sent', 'processed'].includes(scope.row.status.toLowerCase())
                              ? 'Factura nu poate fi generată pentru comenzile cu status SENT sau PROCESSED.'
                              : (scope.row.externalDocIds && scope.row.externalDocIds.invoice) ? 'Factură deja generată'
                              : (scope.row.externalDocIds && 'bonTransfer' in scope.row.externalDocIds) ? 'Bon transfer deja generat'
                              : ''"
                    >
                      <template v-if="scope.row.externalDocIds && scope.row.externalDocIds.invoice">
                        {{ $t('gestiune.invoice') }}: {{ scope.row.externalDocIds.invoice.series }} - {{ scope.row.externalDocIds.invoice.number }}
                      </template>
                      <template v-else>
                        {{ $t('gestiune.invoice') }}
                      </template>
                    </a>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handlePageChange"
                style="margin-top: 15px; text-align: right;"
              ></el-pagination>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'

  export default {
    // components: {
    //   GeneralTopBar
    // },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      gestiuneOptions: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        loadingTimeout: null,
        totalItems: 0,
        currentPage: 1,
        pageSize: 20,
        tableData: [],
        vatNumber: null,
        selectedLocation: null
      }
    },
    computed: {
      showAvizColumn () {
        return this.tableData.some(row => row.externalDocIds && row.externalDocIds.aviz)
      },
      showNirColumn () {
        return this.tableData.some(row => row.externalDocIds && row.externalDocIds.nir)
      },
      showInvoiceColumn () {
        return this.tableData.some(row => row.externalDocIds && row.externalDocIds.invoice)
      }
    },
    watch: {
      selectedLocation (newLocation) {
        this.tableData = []
        this.tableData = []
        this.totalItems = 0
        this.currentPage = 1
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')
    },
    mounted () {
      this.$bus.$on('refresh', () => {
        this.onSearch()
      })
    },
    beforeDestroy () {
      this.$bus.$off('refresh')
    },
    methods: {
      onSearch () {
        // Validare locație
        if (!this.selectedLocation || (Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0)) {
          swal({
            type: 'warning',
            title: this.$t('general.required'),
            text: 'Selectați cel puțin o locație',
            confirmButtonText: 'OK'
          })
          return
        }

        // Pregătim array-ul de locații
        const locations = Array.isArray(this.selectedLocation)
          ? this.selectedLocation
          : [this.selectedLocation]

        // Apelăm fetch-ul efectiv
        this.getMyOrder(locations)
      },
      handlePageChange (page) {
        this.currentPage = page
        this.getMyOrder(this.selectedLocation, this.currentPage, this.pageSize)
      },
      addMyOrder () {
        this.$router.push('/management/for-orders-suppliers/add')
      },
      editMyOrder (row) {
        this.$router.push(`/management/for-orders-suppliers/edit/${row.series}/${row.documentNumber}`)
      },
      getStatusStyle (status) {
        switch (status.toLowerCase()) {
          case 'sent':
            return {
              backgroundColor: '#007bff', // albastru
              color: 'white',
              fontWeight: 'bold',
              padding: '4px 10px',
              borderRadius: '50px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              userSelect: 'none'
            }
          case 'processed':
            return {
              backgroundColor: '#fd7e14', // portocaliu
              color: 'white',
              fontWeight: 'bold',
              padding: '4px 10px',
              borderRadius: '50px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              userSelect: 'none'
            }
          case 'validat':
            return {
              backgroundColor: '#28a745', // verde
              color: 'white',
              fontWeight: 'bold',
              padding: '4px 10px',
              borderRadius: '50px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              userSelect: 'none'
            }
          case 'facturat':
            return {
              backgroundColor: '#6f42c1', // mov
              color: 'white',
              fontWeight: 'bold',
              padding: '4px 10px',
              borderRadius: '50px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              userSelect: 'none'
            }
          case 'new':
            return {
              backgroundColor: '#6c757d', // gri
              color: 'white',
              fontWeight: 'bold',
              padding: '4px 10px',
              borderRadius: '50px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              userSelect: 'none'
            }
          default:
            return {
              backgroundColor: '#343a40', // gri inchis
              color: 'white',
              fontWeight: 'bold',
              padding: '4px 10px',
              borderRadius: '50px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              userSelect: 'none'
            }
        }
      },
      processOrder (row) {
        this.$router.push({
          path: `/management/for-orders-suppliers/edit/${row._id}`,
          query: {
            series: row.series,
            number: row.documentNumber,
            isProcess: true
          }
        })
      },
      aviz (row) {
        this.$router.push({
          path: `/management/outputs/add`,
          query: {
            series: row.series,
            number: row.documentNumber,
            isAviz: true
          }
        })
      },
      invoice (row) {
        this.$router.push({
          path: `/invoice-tabs/invoice/add`,
          query: {
            series: row.series,
            number: row.documentNumber,
            isInvoice: true
          }
        })
      },
      async getMyOrder (location = null, page = 1, pageSize = 25) {
        this.loading = true

        const params = new URLSearchParams()
        params.append('externalCompanyId', this.companyID)

        params.append('page', page)
        params.append('limit', pageSize)

        if (location) {
          if (Array.isArray(location)) {
            const ids = location.map(l => l.true_id).filter(Boolean)
            ids.forEach(id => params.append('externalLocationId', id)) // trimite ca array
          } else if (location.id && location.true_id) {
            params.append('externalLocationId', location.true_id)
          }
        } else {
          const allLocations = this.groupedLocations.flatMap(group => group.locations)
          const ids = allLocations.map(l => l.true_id).filter(Boolean)
          ids.forEach(id => params.append('externalLocationId', id))
        }

        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = setTimeout(() => {
          this.loading = true
        }, 100)

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/orders?${params.toString()}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const data = await response.json()

          if (Array.isArray(data.comenzi)) {
            clearTimeout(this.loadingTimeout)
            this.loading = false

            this.totalItems = data.total || 0
            this.currentPage = data.currentPage || page
            this.pageSize = data.pageSize || pageSize

            this.tableData = data.comenzi
              .filter(order => order.status.toLowerCase() !== 'new')
              .map(order => ({
                _id: order._id,
                series: order.series,
                documentNumber: order.number,
                status: order.status,
                date: order.date,
                externalLocationId: order.externalLocationId,
                supplierVatNumber: order.supplierVatNumber,
                supplierExternalLocationId: order.supplierExternalLocationId,
                externalDocIds: order.externalDocIds || {},
                vatNumber: order.vatNumber
              }))
          } else {
            console.error('No valid orders found.')
            this.tableData = []
          }
        } catch (error) {
          clearTimeout(this.loadingTimeout)
          this.loading = false

          console.error('Error fetching orders:', error)
        }
      }
    }
  }
</script>

<style scoped>
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-button {
display: flex;
align-items: center;
gap: 10px;
}

.left-button el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.editareMultipla .vm--modal,
.bonConsumModal .vm--modal{
  background-color: #F4F6FF;
  border-radius: 10px;
}
.el-pagination {
  text-align: center !important;
}
.checkbox-group {
  display: flex;
  flex-direction: column; /* Aranjează checkbox-urile pe verticală */
}
.checkbox-item {
  margin-bottom: 10px; /* Adaugă un spațiu între checkbox-uri */
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
  margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
  margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
a.delete {
  height: 46px;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Suppliers/ManagementForOrdersSuppliers.vue